export default {
    BOX(state, items) {
        state.items = items
    }
}